import { updatePoll } from '@/lib/server-functions/update-poll';
import { updatePollSchema } from '@/lib/zod-schemas/update-poll.schema';
import { useMutation } from '@tanstack/react-query';
import z from 'zod';

export const useUpdatePoll = () => {
  return useMutation({
    mutationFn: async (payload: z.infer<typeof updatePollSchema>) => {
      return await updatePoll({ data: payload });
    },
  });
};
